import { locationConstant } from '../../constants/constant';

interface ReusableSelectProps<T> {
  options: T[];
  getOptionLabel: (option: T) => string;
  getOptionValue: (option: T) => string | number;
  onChange: (selectedValue: T) => void;
  placeholder?: string;
  className?: string;
  value?: string | number;
  isDisabled?: boolean;
}

function ReusableSelectLocation<T>({
  options,
  getOptionLabel,
  getOptionValue,
  onChange,
  placeholder,
  className,
  value,
  isDisabled = false,
}: ReusableSelectProps<T>) {
  return (
    <select
      className={`p-2 border rounded ${className} `}
      value={value !== null ? String(value) : ''}
      disabled={isDisabled}
      onChange={(e) => {
        const selectedValue = e.target.value;
        const foundOption = options.find(
          (option) => String(getOptionValue(option)) === selectedValue,
        );
        if (foundOption) {
          onChange(foundOption);
        }
      }}
    >
      <option value="" disabled>
        {placeholder}
      </option>
      {options.map((option, index) => {
        const optionValue = getOptionValue(option);
        return (
          <option
            key={index}
            value={String(optionValue)}
            style={{
              backgroundColor:
                optionValue === locationConstant.ownerId
                  ? '#FFDC66'
                  : optionValue === locationConstant.goldCostOwnerId
                    ? '#EEF7FF'
                    : '#EEF7FF',
              color: '#004E9B',
            }}
          >
            {getOptionLabel(option)}
          </option>
        );
      })}
    </select>
  );
}

export default ReusableSelectLocation;
